<template>
  <button
    class="acButton"
    :class="[
      variant ? `-${variant}` : '',
      icon ? `-icon` : '',
      block ? `-block` : '',
      disabled ? `-disabled` : '',
      color ? `-${color}` : ''
    ]"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'

defineProps({
  block: {
    type: Boolean,
    default: false
  },
  icon: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  variant: {
    type: String as PropType<'tonal' | 'outlined' | 'text'>,
    default: null
  },
  color: {
    type: String as PropType<'primary' | 'gray'>,
    default: 'primary'
  }
})
</script>

<style lang="scss">
@import '@web/assets/scss/textContsnts.scss';

.acButton {
  cursor: pointer;
  border-radius: 42px;
  padding: 12px 18px;
  color: var(--ac-color-white);
  background-color: var(--ac-color-deep-liliac);
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
  outline: none;
  @extend .text-base;

  &.-gray {
    color: var(--ac-color-black);
    background-color: var(--ac-color-gray);
  }

  &.-block {
    width: 100%;
  }

  &.-icon {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  &.-disabled,
  &[disabled] {
    background-color: var(--ac-color-liliac-secondary);
    cursor: default;
  }

  &.-disabled.-gray,
  &[disabled].-gray {
    background-color: var(--ac-color-light-gray);
    cursor: default;
  }

  &.-text {
    background: transparent;
    border: none;
  }

  &.-outlined {
    color: var(--ac-color-deep-liliac);
    background-color: transparent;
    border: 1px solid var(--ac-color-deep-liliac);
  }

  &.-outlined.-gray {
    color: var(--ac-color-black);
    background-color: transparent;
    border: 1px solid var(--ac-color-light-gray);
  }

  &.-outlined.-disabled.-gray,
  &.-outlined[disabled].-gray {
    color: var(--ac-color-gray);
    border: 1px solid var(--ac-color-gray);
    cursor: default;
  }
}
</style>
